import React from 'react';

interface DashboardContextMenuContextType {
  isOpen: boolean;
  // A series with query overrides opens its records as it asks for them
  openMenu: (
    metricIds: string[],
    drillDown: FixedFilter,
    queryOverrides?: V5SeriesQueryOverrides,
  ) => void;
  drillDown?: FixedFilter;
  queryOverrides?: V5SeriesQueryOverrides;
  closeMenu: () => void;
  metricIds: string[];
  selectedMetric?: Metrics.NormalMetric | Metrics.SpecialMetric;
  setSelectedMetric: React.Dispatch<
    React.SetStateAction<
      Metrics.NormalMetric | Metrics.SpecialMetric | undefined
    >
  >;
}

const DashboardContextMenuContext =
  React.createContext<DashboardContextMenuContextType>(
    {} as DashboardContextMenuContextType,
  );

export default DashboardContextMenuContext;
